import { createFileRoute, redirect } from "@tanstack/react-router"

import { getBoardsQueryOptions } from "@/api/query/boardsQueryOptions"
import { routeGuard } from "@/lib/routing/beforeLoad"
import { isUUIDFormat } from "@/lib/utils/validation"

import { templateName } from "../-templateQuery"

export const Route = createFileRoute("/_authlayout/_header/templates/$id/edit/")({
  beforeLoad: async ({ context, params }) => {
    await routeGuard(context, {
      permission: { flag: "iot:template::update", fallbackRoute: { to: "/templates/$id", params: { id: params.id } } }
    })
    // Only a user's own (custom) template is editable.
    if (!isUUIDFormat(params.id)) {
      throw redirect({ to: "/templates/$id", params: { id: params.id } })
    }
  },
  loader: ({ context }) => context.queryClient.query({ ...getBoardsQueryOptions(), staleTime: "static" }),
  head: ({ match }) => {
    const title = templateName(match.context.templateQuery) || "Template"

    return { meta: [{ title: `Edit ${title} | Arduino Cloud` }] }
  }
})
